/*
  This code defines a JavaScript module for managing a shopping cart section on a webpage. It includes functions for initializing the cart section and loading its template.

  - cartSection(): A function that returns an object representing the cart section module. It contains two methods:
    - init(): Initializes the cart section by loading its template.
    - loadTemplate(): Loads the template for the cart section from a specified HTML element, and replaces the content of a target element with the loaded template. This is so that we are not writing separate HTML/CSS/JS in cart page and we leverage what we wrote for the cart drawer

  The module is then registered with Alpine.js to be used in the HTML as a component.
*/
const cartSection = () => ({
  init() {
    this.loadTemplate();
  },

  loadTemplate() {
    const content = document.querySelector('.js-cart-template').content.cloneNode(true);
    content.querySelector('.cart').classList.add('cart--section');
    this.$refs.target.replaceChildren(content);
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('cartSection', cartSection);
});
